<template>
  <myhead @next="next">{{$route.query.title||$route.meta.title}}</myhead>

  <div v-if="errMessage" class="center">
    <van-empty :description="errMessage" />
  </div>
  <div v-else class="ml15 mr15">
    <div v-if="step<4">
      <span class="b500 mr3">{{detail.name}}</span><span class="opacity8 em80">{{detail.no}}</span>
      <p class="C999 size12 mb10 mt10">{{detail.add_time}}</p>
      <p>简介：{{detail.description}}</p>
      <p class="size12 mt8">发布人：{{detail.publish_name}} &nbsp;&nbsp;&nbsp;推荐人：{{detail.recommend||'-'}}</p>
      <div class="Con mb10 mt10 relative">
        <span @click="step=step==2?1:2">综合评分： <span class="C222">{{detail.score_star}}</span></span>
        <span @click="step=step==3?1:3"> &nbsp;&nbsp;&nbsp;文化价值：<span class="C222">{{detail.invest_amount}}</span></span>
        <ul class="absolute mt30 t gray C888 l BGwhite part02" v-show="step==2">
          <li>评分人数：{{detail.score_num}}</li>
          <li>平均分值：{{detail.score_star}}</li>
          <li @click="$store.state.loginInfo.token ? $router.push({path:'/vote/score',query:$route.query}) : $router.push({path:'/login',query:{column_type:2}})">我要评分</li>
          <li @click="setStep(4)">评分总览</li>
          <li @click="$router.push({path:'/feedback'})">意见建议</li>
        </ul>
        <ul class="absolute mt30 ml125 t gray C888 l BGwhite part02" v-show="step==3">
          <li>投资人数：{{detail.invest_num}}</li>
          <li>投资金额：{{detail.invest_amount}}</li>
          <li @click="$store.state.loginInfo.token ? $router.push({path:'/vote/invest',query:$route.query}) : $router.push({path:'/login',query:{column_type:2}})">我要投资</li>
          <li @click="setStep(4)">评分总览</li>
          <li @click="setStep(5)">主题排名</li>
        </ul>
      </div>
    </div>
    <img class="width100 radius10 mb15 contain BGf0" :onerror="imgError" :src="detail.image" alt="" v-if="step<4">
    <img :src="detail.score_overview" :onerror="imgError" class="mb15 width100 radius8" alt="" v-if="step==4">
    <img :src="detail.invest_ranking" :onerror="imgError" class="mb15 width100 radius8" alt="" v-if="step==5">
    <div class="flex C999">
      <p>浏览量：{{detail.browse}}</p>
      <p class="ml25">浏览人数：{{detail.invest_num}}</p>
      <p class="ml25">评价人数：{{detail.score_num}}</p>
    </div>
  </div>
  <!-- <div @click="$router.push({path:'/feedback'})" class="fixed l b mb80 Cfff" style="border-radius:0 20px 20px 0;padding:10px 18px;background:#85A6B1">意见反馈</div> -->
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
      errMessage:null,
      detail:{},
      step:1
    }
  },
  watch:{
    $route:{
      deep:true,
      handler(v){
        let step = v.query.step || 1;
        step = Number(step);
        this.step = step;
      }
    }
  },
  methods:{
    setStep(step){
      this.$router.push({query:{...this.$route.query,step}})
    },
    next(){
      
    }
  },
  created(){
    let { step } = this.$route.query;
    if(step){
      this.step = Number(step);
    }
    this.ajax.post("rulelaws/getplebisciteinfo",{...this.$route.query}).catch(({data})=>{
      let {message} = data;
      this.errMessage = message
    }).then(({data})=>{
      this.detail = data;
    })
  }
}
</script>

<style>
</style>
